var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown-item',{attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.seeAllInitiatives($event)}}},[_vm._v("\n  See "+_vm._s(_vm.type)+" Initiatives\n")])}
var staticRenderFns = []

export { render, staticRenderFns }